module.exports = "https://static.wmbcdn.com/uniweb/images/4df1d0e85b269bd357b621156b1934fb.svg";